import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
 
const Testing = () => {
  const location = useLocation();
  const navigate = useNavigate();
 
  useEffect(() => {
    // 현재 URL 경로를 가져옵니다.
    const path = location.pathname;
      console.log("Testing component is rendered.");

    // 특정 문자열 'cpdlsxmflchlrh^^'이 경로에 포함되어 있는지 확인합니다.
    if (path.includes('/testing/cpdlsxmfltjdrhd0818')) {
      const now = new Date();
      // localStorage에 사용자 정보를 설정합니다.
      localStorage.setItem('userID', '1024');
      localStorage.setItem('userName', '테스팅');
      localStorage.setItem('loginTime',  now);
      localStorage.setItem('userType', 'teacher');
 
      console.log('✅ 사용자 정보가 localStorage에 저장되었습니다.');
 
      // /home 경로로 페이지를 이동시킵니다.
      console.log("userID:", localStorage.getItem("userID"));

      navigate('/home');
    }
    else{
          alert('올바르지 않은 접근입니다.');
    }
  }, [location, navigate]);
 
  return (
    <div>
      <p>테스트 페이지입니다. URL 경로를 확인 중...</p>
    </div>
  );
};
 
export default Testing;